export default {
  account: {},
  dialog: false,
  tabType: null,
  formData: {},
  isVisibleTab: false,
}
